import { makeActionCreator } from '../../../utilities'
import { DocumentScannerConstants } from './documentScanner.constants'

export const setScannedDocuments = makeActionCreator(DocumentScannerConstants.SET_SCANNED_DOCUMENTS, 'scannedDocuments')

export const importDocuments = makeActionCreator(DocumentScannerConstants.IMPORT_DOCUMENTS)
export const getDocumentAttachments = makeActionCreator(DocumentScannerConstants.GET_DOCUMENT_ATTACHMENTS)
export const setDocumentAttachments = makeActionCreator(
  DocumentScannerConstants.SET_DOCUMENT_ATTACHMENTS,
  'documentAttachments'
)
export const setDisableScanButton = makeActionCreator(
  DocumentScannerConstants.SET_DISABLE_SCAN_BUTTON,
  'disableScanButton'
)

export const deleteDocumentAttachment = makeActionCreator(
  DocumentScannerConstants.DELETE_DOCUMENT_ATTACHMENT,
  'documentAttachmentToDelete'
)

export const resetDocumentScannerState = makeActionCreator(DocumentScannerConstants.RESET_DOCUMENT_SCANNER_STATE)
